
class ProductCardVariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      const productHandle = this.getAttribute('data-product-handle');
      const optionValues = this.selectedOptionValues();

      const url = `${window.location.origin}/products/${productHandle}?view=ajax-product-card&option_values=${optionValues.join(',')}`;
      this.renderCard(url);

    });
    this.toggleProductInfo();
  }

  renderCard(url) {
    fetch(url)
        .then((response) => response.text())
        .then((responseText) => {

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        
        const ajaxCardWrapper = html.querySelector('[js-product-card]');
        const currentCardWrapper = this.closest('[js-product-card]');
        
        currentCardWrapper.innerHTML = ajaxCardWrapper.innerHTML;

        const productOptionsAndBtnWrapper = currentCardWrapper.querySelector(".card-product-options-and-btn");
        const productOptionsAndBtnWrapperHeight = currentCardWrapper.querySelector("[js-product-options-and-btn-wrapper]")?.clientHeight;

        productOptionsAndBtnWrapper.style.height = productOptionsAndBtnWrapperHeight + "px";
        productOptionsAndBtnWrapper.style.overflow = "visible";

        const sizeChartBtn = currentCardWrapper.querySelector("[js-size-chart-btn]");
        const popOverlay = document.querySelector(".popOverlay");
        const popContainer = document.querySelector(".chart_popContent");
        const closeBtn = document.querySelector(".closeBtn");
        const body = document.querySelector("body");

        if (popContainer){
          sizeChartBtn.addEventListener("click", function () {
            popOverlay.classList.add("active");
            popContainer.classList.add("active");
            body.classList.add("noScroll");
          });
          
          function closePopup() {
            popOverlay.classList.remove("active");
            popContainer.classList.remove("active");
            body.classList.remove("noScroll");
          }
          
          popOverlay.addEventListener("click", closePopup);
          closeBtn.addEventListener("click", closePopup);
        }

    })
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

 selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }

  toggleProductInfo() {
    const toggleArrow = this.closest('[js-product-card]').querySelector(".card__content.SSSS .toggle_arrow");
    toggleArrow.addEventListener('click', function (event) {
        const gridItem = toggleArrow.closest("[js-product-card]");
        const productOptionsAndBtnWrapper = gridItem.querySelector(".card-product-options-and-btn");
        const productOptionsAndBtnWrapperHeight = gridItem.querySelector("[js-product-options-and-btn-wrapper]")?.clientHeight;
        if (!gridItem) return;
        if (gridItem.classList.contains("active")) {
            gridItem.classList.remove("active");
            productOptionsAndBtnWrapper.style.overflow = "hidden";
            productOptionsAndBtnWrapper.style.height = "0";
        } else {
            gridItem.classList.add("active");
            productOptionsAndBtnWrapper.style.height = productOptionsAndBtnWrapperHeight + "px";
            setTimeout(() => {
                 productOptionsAndBtnWrapper.style.overflow = "visible";
            }, 200);
        }
    });
  }

}

customElements.define('prodcut-card-variant-selects', ProductCardVariantSelects);